<template>
  <div class="position-relative whats-new">
    <WhatsNewCardsLoading>
      <template #default>
        <div class="whats-new__line">
          <div
            v-for="(item, index) in itemsFiltered"
            :key="`a-${index}`"
            class="position-relative"
          >
            <fade-transition :delay="300">
              <b-row v-if="!item.deleted" class="whats-new__card">
                <b-col cols="12" class="whats-new__top-row">
                  <span>{{ `${$lang.version} ${item.version}` }}</span>
                  <span>{{ item.changeDate }}</span>
                </b-col>
                <b-col
                  v-for="(typeItem, typeIndex) in item.typeItems"
                  :key="`b-${typeIndex}`"
                  cols="12"
                  class="padding-0"
                >
                  <b-row class="margin-0">
                    <b-col cols="12" class="whats-new__type-box">
                      <span
                        :class="`margin-left-8 color-${generateTypeColor(
                          typeItem.id
                        )}`"
                      >
                        <mdicon name="circle" size="10" />
                      </span>
                      <span>{{ typeItem.type }}</span>
                    </b-col>
                    <b-col
                      v-for="(subItem, subIndex) in pathOr(
                        [],
                        ['items'],
                        typeItem
                      )"
                      :key="`c-${subIndex}`"
                      cols="12"
                      class="whats-new__description"
                    >
                      <div class="padding-left-8">
                        <span class="whats-new__description-dot">
                          {{ "." }}
                        </span>
                        {{ subItem.description }}
                      </div>
                      <div class="whats-new__options">
                        <span
                          v-if="checkPermission(permissions, ['admin'])"
                          class="whats-new__options-item"
                          @click="showDeleteModal(subItem)"
                        >
                          <mdicon name="trash-can-outline" size="16" />
                        </span>
                        <span
                          v-if="checkPermission(permissions)"
                          class="whats-new__options-item"
                          @click="showEditPin(subItem)"
                        >
                          <mdicon name="pencil-outline" size="16" />
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </fade-transition>
          </div>
        </div>
      </template>
    </WhatsNewCardsLoading>
    <WhatsNewEditPin
      :visible="editPin"
      :itemId="currentItemId"
      :permissions="permissions"
      @reload="listWrapperReload"
      @close="closeEditPin"
    />
    <Modal
      :show="deleteModal"
      :title="$lang.delete_history"
      :closeOnBackdrop="false"
      :hasClose="false"
      :okButton="true"
      :okButtonText="$lang.delete"
      okButtonVariant="filled-error"
      size="sm"
      :okLoading="deleteLoading"
      :ok="remove"
      @close="closeDeleteModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.remove_sure_message.replace("{0}", $lang.history) }}
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import WhatsNewCardsLoading from "./whatsNewCardsLoading.vue";
import WhatsNewEditPin from "../components/WhatsNewEditPin.vue";
import Modal from "@/components/re-design/modal/Modal.vue";
import { pathOr } from "ramda";
import { computed, inject, ref, toRefs } from "vue";
import { deleteWhatsNew } from "@/modules/profile/services";
import { generateError, toastAlert, checkPermission } from "@/shared/utils";

export default {
  components: { WhatsNewCardsLoading, WhatsNewEditPin, Modal },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  methods: { pathOr, checkPermission },
  setup(props) {
    // generate props data
    const { items, permissions } = toRefs(props);

    // injection data
    const listWrapperReload = inject("listWrapperReload");

    // generate data
    const itemsFiltered = computed(() => {
      const data = items.value || [];
      return data.map((item) => {
        return {
          ...item,
          changeDate: pathOr("", ["change_date"], item),
          typeItems: pathOr([], ["type_items"], item),
          deleted: false,
        };
      });
    });

    const currentItemId = ref(null);

    // edit data
    let editPin = ref(false);
    const showEditPin = (item) => {
      currentItemId.value = +pathOr(null, ["id"], item);
      editPin.value = true;
    };
    const closeEditPin = () => {
      editPin.value = false;
    };

    // delete data
    const deletedItemsId = ref([]);
    const deleteModal = ref(false);
    const deleteLoading = ref(false);
    const showDeleteModal = (item) => {
      currentItemId.value = +pathOr(null, ["id"], item);
      deleteModal.value = true;
    };
    const closeDeleteModal = () => {
      currentItemId.value = null;
      deleteModal.value = false;
    };
    const remove = async () => {
      try {
        deleteLoading.value = true;
        const id = currentItemId.value;
        const response = await deleteWhatsNew(id);
        const { message } = response;
        toastAlert(message);
        deletedItemsId.value.push(id);
        closeDeleteModal();
        listWrapperReload();
      } catch (error) {
        generateError(error);
      } finally {
        deleteLoading.value = false;
      }
    };

    // helper methods
    const generateTypeColor = (id = 0) => {
      const typesObj = {
        0: "light-gray",
        1: "success",
        2: "primary",
        3: "warning",
        4: "error",
      };
      return pathOr("", [id], typesObj);
    };

    return {
      itemsFiltered,
      permissions,
      currentItemId,
      editPin,
      showEditPin,
      closeEditPin,
      deletedItemsId,
      deleteModal,
      deleteLoading,
      showDeleteModal,
      closeDeleteModal,
      remove,
      generateTypeColor,
      listWrapperReload,
    };
  },
};
</script>
